export default __webpack_public_path__ + "static/media/ic_dashboard.ed98de1c.svg";